/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';

const deps = {};

/*---------------------------------------------------------*\
 * Weakmaps
 \*---------------------------------------------------------*/
const TIMEOUT = new WeakMap();
const TOPICS = new WeakMap();
const NAVIGATION = new WeakMap();

/*---------------------------------------------------------*\
 * TrafficHomeLanding
\*---------------------------------------------------------*/
class TrafficHomeLandingController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($state, $stateParams, $scope, $timeout, topics, navigationService, localService, storageKeys, states,
              trafficService, adProps) {
    TIMEOUT.set(this, $timeout);
    TOPICS.set(this, topics);
    NAVIGATION.set(this, navigationService);

    deps.trafficService = trafficService;
    this.adProps = adProps;

    deps.$state = $state;
    deps.$stateParams = $stateParams;
    this.name = 'trafficHomeLanding';
    deps.states = states;
    this.$scope = $scope;
    this.showCameras = false;
    this.pausemapOn = false;


    deps.localService = localService;
    // this.currentRegion is the LOCAL region variable
    this.currentRegion = deps.$stateParams.subRegion ? JSON.parse(deps.$stateParams.subRegion) :
        localService.get(storageKeys.selectedRegion);

    this.leftNavItems = [
      {
        id: 'news',
        title: 'News',
        state: states.home,
        sections: []
      },
      {
        id: 'weather',
        title: 'Weather',
        state: states.weather_center,
        sections: []
      }
    ];
    this.subnavMenuItems = [
      {
        title: (this.pausemapOn ? 'Resume Maps' : 'Pause Maps'),
        id: 'Maps'
      },
      {
        title: 'Cameras',
        id: 'Cameras'
      },
      {
        title: 'Delays',
        id: 'Delays'
      },
      {
        title: 'Region',
        id: 'Region'
      }
    ]; // TODO, render items dynamically

    const token2 = PubSub.subscribe(topics.component.selectPhotos, (msn, data) => {
      this.cameras = data;
      this.showCameras = this.cameras.showCameras;
      this.showCamerasPhotos = this.cameras.showCamerasPhotos;
    });

    const token = PubSub.subscribe(TOPICS.get(this).nav.enter, (msg, data) => {
      if (data.source === 'navbar') {
        this.showCamerasPhotos = false;
        // When clicking on subnav
        if (data.data === this.subnavMenuItems[0]) {
          const item = data.data;
          this.pausemapOn = !this.pausemapOn;
          data.data.title = (this.pausemapOn ? 'Resume Maps' : 'Pause Maps');
          PubSub.publish(TOPICS.get(this).component.slideshowToggle, { data: item, pausemapOn: this.pausemapOn });
        } else if (data.data.title === 'Cameras') {
          this.showCameras = true;
          this.pausemapOn = true;
        } else {
          this.pausemapOn = true;
        }
        this.subNavSelect(data.data);
        this.$scope.$apply();
      }
    });
    $scope.$on('$destroy', PubSub.unsubscribe.bind(PubSub, token));
    $scope.$on('$destroy', PubSub.unsubscribe.bind(PubSub, token2));
    this.subNavSelect(this.subnavMenuItems[0]);
    // focus on index 0 in subnavbar
    this.selectedIndex = 0;
    this.$onInit = () => {
      trafficService.getTrafficPlaypauseMaps(this.currentRegion.abbr).then(this.applyMap.bind(this));
    };
  }

  //-----------------------------------
  // Properties
  //-----------------------------------
  //-----------------------------------
  // Methods
  //-----------------------------------
  applyMap(item) {
    TIMEOUT.get(this)(() => {
      this.maps = item.data;
    });
  }

  subNavSelect(item) {
    this.showCamerasPhotos = false;
    this.activeSection = item;
    // This initial timeout is necessary to wait for the old .main-content to have
    // been cleared from the DOM
    TIMEOUT.get(this)(() => {
      // focus on navbar
      NAVIGATION.get(this).focusElAsync('.selected');
    });
  }

  isActiveSection(section) {
    return section === this.activeSection.id;
  }

  navSelect(item) {
    if (item && item.state) {
      deps.$state.go(item.state);
    }
  }

  onRegionSelect(region) {
    TIMEOUT.get(this)(() => {
      deps.trafficService.getTrafficPlaypauseMaps(region.abbr).then(this.applyMap.bind(this));
    });
    deps.$state.go(deps.$state.$current, { subRegion: JSON.stringify(region) });
  }

  //-----------------------------------
  // Events
  //-----------------------------------
}

TrafficHomeLandingController.$inject = [
  '$state',
  '$stateParams',
  '$scope',
  '$timeout',
  'topics',
  'navigationService',
  'localService',
  'storageKeys',
  'states',
  'trafficService',
  'adProps'
];

export default TrafficHomeLandingController;



/** WEBPACK FOOTER **
 ** ./client/app/components/trafficHomeLanding/trafficHomeLanding.controller.js
 **/